<template>
  <v-footer
    id="home-footer"
    color="black"
    dark
    class="home-footer"
  >
    <v-container>
      <v-row class="footer-row">
        <v-col
          cols="12"
          md="6"
        >
          <div class="footer-links d-flex flex-wrap justify-md-start justify-center">
            <template v-for="(s, i) in social">
              <a
                :key="s.title"
                class="white--text footer-link"
                :href="s.url"
                v-text="s.title"
                target="_blank"
                rel="noopener noreferrer"
              />

              <v-responsive
                v-if="i < social.length - 1"
                :key="`divider-${s.title}`"
                class="mx-4 shrink hidden-sm-and-down"
                max-height="24"
              >
                <v-divider vertical />
              </v-responsive>
            </template>
          </div>
        </v-col>

        <v-col
          class="text-center text-md-right footer-copy"
          cols="12"
          md="6"
        >
          Copyright &copy; PT Asuransi Takaful Umum
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'HomeFooter',

    data: () => ({
      social: [
        { title: 'Facebook', url: 'https://id-id.facebook.com/AsuransiTakafulUmum' },
        { title: 'Twitter', url: 'https://twitter.com/takafulumum' },
        { title: 'Instagram', url: 'https://instagram.com/takafulumum' },
        { title: 'Linkedin', url: 'https://id.linkedin.com/company/pt-asuransi-takafulumum' },
      ],
    }),
  }
</script>

<style lang="sass">
  .home-footer
    min-height: auto !important
    padding: 16px 0

  .footer-row
    align-items: center
    row-gap: 8px

  #home-footer a
    text-decoration: none

  .footer-links
    gap: 8px 0
    line-height: 1.5

  .footer-link
    display: inline-block
    padding: 4px 6px

  .footer-copy
    line-height: 1.5

  @media (max-width: 767.98px)
    .home-footer
      padding: 18px 0 22px

    .footer-links
      justify-content: center

    .footer-copy
      font-size: 0.92rem
</style>
